import styled from 'styled-components';
import { Body } from 'components/Typography';
import DefaultAvatar from 'components/Avatar';
import addAlpha from 'utils/addAlpha';
import { Link as DefaultLink } from 'react-router-dom';

// TODO: TFR-44 move to container group
export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-gap: 2rem;
  padding: 1.5625rem 2.125rem;
  justify-content: center;
  align-items: flex-start;
`;

// TODO: TFR-45:Name make unique name or do not export
export const Name = styled(Body)`
  font-weight: 600;
  font-size: 1.1875rem;
`;

// TODO: TFR-45:Date make unique name or do not export
export const Date = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  font-size: 1.0625rem;
  font-variant-numeric: tabular-nums;
`;

// TODO: TFR-44 move to container group or do not export
export const CommentContainer = styled(Body)`
  max-width: 30rem;
  font-size: 1.0625rem;
`;

// TODO: TFR-44 move to container group or do not export
export const OrderContainer = styled.div`
  display: flex;
  align-items: center;
`;

// TODO: TFR-45:Text make unique name or do not export
export const Text = styled(Body)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

// TODO: TFR-45:Avatar make unique name or do not export
export const Avatar = styled(DefaultAvatar)`
  margin-right: 1rem;
`;

// TODO: TFR-45:Link make unique name or do not export
export const Link = styled(DefaultLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.greenMedium};
  font-weight: 600;
  font-size: 1.1875rem;
  margin-top: 0.87rem;
`;
